import { useFonts } from 'expo-font';
import { BrowserRouter } from 'react-router-dom';

import PublicRouter from 'components/layouts/Public/Router';
import VersionSyncComp from 'components/providers/VersionSync';

interface App {
  disableSecureCookie?: boolean;
  VersionSync?: typeof VersionSyncComp;
}

function App({
  VersionSync = VersionSyncComp,
}: App): JSX.Element | null {
  useFonts({
    CircularStdBlack: require('assets/fonts/CircularStdBlack.otf'),
    CircularStdMedium: require('assets/fonts/CircularStdMedium.otf'),
    CircularStdBook: require('assets/fonts/CircularStdBook.otf'),
    GTPressuraPro: require('assets/fonts/GTPressuraProBold.otf'),
    InterRegular: require('assets/fonts/InterRegular.woff2'),
    InterMedium: require('assets/fonts/InterMedium.woff2'),
    InterSemibold: require('assets/fonts/InterSemibold.woff2'),
  });

  return (
    <BrowserRouter>
      <VersionSync>
        <PublicRouter />
      </VersionSync>
    </BrowserRouter>
  );
}

export default App;
